import React, { useState, useEffect, useMemo } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import {
  SelectTagTable,
  TableContent,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  SelectTagHead,
  SelectTagTitle,
  SelectTagWidgetContainer,
  SelectTagSearchContainer,
  ColorCircle,
  BroadcastAppCard,
  TableHeaderText,
  TransparentBackground,
  ConjunctionContainer,
  ConjunctionTitle,
  ConjunctionGreenTitle,
  ConjunctionOptions,
  ConjunctionOption,
  ConjunctionImg,
  ConjunctionSelect,
  ConjunctionButtonContainer,
  ConjunctionButton,
} from "./BroadcastView.styles";
import { BackLink } from "./Campaigns.style";
import Search from "../../../components/search/Search";
import LoaderComponent from "../../../components/loader/Loader.component";
import { getTagsCount } from "../../../utils/tag";
import Button from "../../../components/shared/components/button/Button.style";
import { dateFromNowLongVersion } from "../../../tools/date-utils";
import {
  setSelectedConjunctionAction,
  setSelectedTagsAction,
} from "../../../redux/campaignDuck";

import unionImg from "../../../assets/images/union.png";
import intersectionImg from "../../../assets/images/intersection.png";
import differenceImg from "../../../assets/images/difference.png";
import conjunctionButtonImg from "../../../assets/images/conjunction-button.png";
import { Checkbox } from "@material-ui/core";

const BLOCKED_COMPANIES = [
  '65ef4042a7b11b00080b60b2',
  '643f1141a7b11b00089408a6',
  '64d27d7ea7b11b0008795fa8'
];

const PAGE_SIZE = 30;

const BroadcastSelectTagView = ({ accountLimitOfMessages, isFromContacts, companyId, parentCallAction, globalTags, selectedTags }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const channelId = useSelector((state) => state.campaign.create.channelId);
  const _companyId = useSelector((state) => state.user.data?.company?.id);

  const [allTags, setAllTags] = useState([]);
  const [tags, setTags] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isChecked, setIsChecked] = useState();
  const [query, setQuery] = useState("");
  const [isLimitWarningOpen, setIsLimitWarningOpen] = useState(false);
  const [conjunctionType, setConjunctionType] = useState(null);
  const [isConjunctionSelectOpen, setIsConjunctionSelectOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [goToPageInput, setGoToPageInput] = useState("");

  const totalPages = useMemo(() => Math.ceil(tags.length / PAGE_SIZE), [tags]);
  const paginatedTags = useMemo(
    () => tags.slice(currentPage * PAGE_SIZE, (currentPage + 1) * PAGE_SIZE),
    [tags, currentPage]
  );

  const getTagsAction = async () => {
    const checks = [];
    setIsLoading(true);
    let fetchedTags;
    if (isFromContacts === true) {
      fetchedTags = globalTags;
      for (let tag of fetchedTags) {
        checks.push(selectedTags?.some(id => id === tag?.id))
      }
    } else {
      fetchedTags = await getTagsCount(channelId === "" ? null : channelId , companyId);
      fetchedTags.forEach(() => {
        checks.push(false);
      });
    }
    setIsChecked(checks);
    setAllTags(fetchedTags);
    setTags(fetchedTags);
    setCurrentPage(0);
    setIsLoading(false);
  };

  useEffect(() => {
    if (BLOCKED_COMPANIES.includes(_companyId)) history.push("/maintenance");
    else if (!channelId && !isFromContacts) history.push("/broadcast/table");
    else {
      getTagsAction()
    };
  }, [channelId]);

  const handleActionButton = () => {

    if (isFromContacts === true) {
      const ids = [];
      isChecked.forEach((item, index) => {
        if (item) {
          ids.push(tags[index].id);
        }
      });
      parentCallAction(ids);
    } else {
      const ids = [];
      let count = 0;
      dispatch(setSelectedConjunctionAction(null));
      isChecked.forEach((item, index) => {
        if (item) {
          ids.push(tags[index].id);
          count += tags[index].clientCount;
        }
      });
      if (count > accountLimitOfMessages) {
        setIsLimitWarningOpen(true);
      } else {
        dispatch(setSelectedTagsAction(ids));
        history.push("/broadcast/selectTemplate");
      }
    }
  };

  const handleModalActionButton = () => {
    const ids = [];
    isChecked.forEach((item, index) => {
      if (item) {
        ids.push(tags[index].id);
      }
    });
    dispatch(setSelectedTagsAction(ids));
    history.push("/broadcast/selectTemplate");
  };

  const handleModalCancelButton = () => {
    setIsLimitWarningOpen(false);
  };

  const handleQueryChange = (event) => {
    setQuery(event.target.value);
  };

  const handleCheck = (_, globalIndex) => {
    const newChecked = isChecked.map((_, i) => i === globalIndex ? !isChecked[globalIndex] : false);
    setConjunctionType(null);
    setIsConjunctionSelectOpen(false);
    setIsChecked(newChecked);
  };

  const selectConjunctionType = (type) => {
    setConjunctionType(type);
  };

  const openConjunctionSelect = () => {
    setIsConjunctionSelectOpen(true);
  };

  const closeConjunctionSelect = () => {
    setIsConjunctionSelectOpen(false);
  };

  useEffect(() => {
    if (query.length > 0) {
      const filteredData = allTags.filter((item) => {
        const regex = new RegExp(query, "gi");
        return regex.test(item.name);
      });
      setTags(filteredData);
      const filteredChecks = filteredData.map((tag) => {
        const originalIndex = allTags.findIndex((t) => t.id === tag.id);
        return isChecked?.[originalIndex] || false;
      });
      setIsChecked(filteredChecks);
      setCurrentPage(0);
      setIsLoading(false);
    } else if (allTags.length > 0) {
      setTags(allTags);
      setIsChecked(allTags.map(() => false));
      setCurrentPage(0);
    } else {
      getTagsAction();
    }
  }, [query]);

  return (
    <>
      <SelectTagWidgetContainer>
        <BroadcastAppCard>
          {!isFromContacts && (
            <BackLink onClick={() => history.push("/broadcast/type")}>
              ← Regresar
            </BackLink>
          )}
          <SelectTagHead>
            {!isFromContacts && (<>
              <TableHeaderText>
                Envía un mensaje a varias personas al mismo tiempo creando
                campañas. Puedes usar una lista de contactos en un archivo Excel o
                seleccionar grupos específicos para enviar tu mensaje.
              </TableHeaderText>
            </>)}
            <SelectTagSearchContainer templateHead>
              <Search
                handleSearch={handleQueryChange}
                value={query}
                label={"Buscar etiquetas..."}
                templateSelection
              />
            </SelectTagSearchContainer>
          </SelectTagHead>
          <TableContent>
            <SelectTagTable onClick={() => {}}>
              {isLoading ? (
                <LoaderComponent width="32px" height="32px" />
              ) : (
                <>
                  <Thead>
                    <Th left style={{ width: "20%" }}>
                      Nombre de etiqueta
                    </Th>
                    <Th style={{ width: "20%" }}>Fecha de creación</Th>
                    <Th left>Color</Th>
                    {!isFromContacts && (<Th style={{ width: "20%" }}>Número de contactos</Th>)}
                    <Th></Th>
                  </Thead>
                  <Tbody>
                    {paginatedTags.map((val, localIndex) => {
                      const globalIndex = currentPage * PAGE_SIZE + localIndex;
                      return (
                        <Tr key={val.id || globalIndex}>
                          <Td style={{ width: "20%" }} left>
                            {val.name}
                          </Td>
                          <Td>{dateFromNowLongVersion(val.createdAt)}</Td>
                          <Td style={{ width: "5%" }}>
                            <ColorCircle color={val.color} />
                          </Td>
                          {!isFromContacts && (
                            <Td style={{ width: "25%" }}>
                              {val.clientCount || 0}
                            </Td>
                          )}
                          <Td>
                            <input
                              type="radio"
                              name="selectedTag"
                              checked={isChecked?.[globalIndex] || false}
                              onChange={() => {
                                handleCheck(val, globalIndex);
                              }}
                            />
                          </Td>
                        </Tr>
                      );
                    })}
                  </Tbody>
                </>
              )}
            </SelectTagTable>
            {totalPages > 1 && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: "8px",
                  padding: "16px 0",
                  fontFamily: "SpaceGrotesk-Medium, sans-serif",
                  fontSize: "13px",
                  color: "#2E3353",
                }}
              >
                <div style={{ display: "flex", alignItems: "center", gap: "4px", flexWrap: "wrap", justifyContent: "center" }}>
                  <button
                    onClick={() => setCurrentPage(0)}
                    disabled={currentPage === 0}
                    style={{
                      width: "32px", height: "32px",
                      border: "1px solid #d9d9d9", borderRadius: "4px",
                      backgroundColor: "white", cursor: currentPage === 0 ? "not-allowed" : "pointer",
                      color: currentPage === 0 ? "#bbb" : "#2E3353",
                      fontFamily: "SpaceGrotesk-Medium, sans-serif", fontSize: "13px",
                    }}
                  >
                    «
                  </button>
                  <button
                    onClick={() => setCurrentPage((p) => Math.max(0, p - 1))}
                    disabled={currentPage === 0}
                    style={{
                      width: "32px", height: "32px",
                      border: "1px solid #d9d9d9", borderRadius: "4px",
                      backgroundColor: "white", cursor: currentPage === 0 ? "not-allowed" : "pointer",
                      color: currentPage === 0 ? "#bbb" : "#2E3353",
                      fontFamily: "SpaceGrotesk-Medium, sans-serif", fontSize: "13px",
                    }}
                  >
                    ‹
                  </button>
                  {(() => {
                    const pages = [];
                    let start = Math.max(0, currentPage - 3);
                    let end = Math.min(totalPages - 1, currentPage + 3);
                    if (currentPage <= 3) end = Math.min(totalPages - 1, 6);
                    if (currentPage >= totalPages - 4) start = Math.max(0, totalPages - 7);

                    if (start > 0) {
                      pages.push(
                        <button key={0} onClick={() => setCurrentPage(0)}
                          style={{
                            width: "32px", height: "32px",
                            border: "1px solid #d9d9d9", borderRadius: "4px",
                            backgroundColor: "white", cursor: "pointer",
                            color: "#2E3353",
                            fontFamily: "SpaceGrotesk-Medium, sans-serif", fontSize: "13px",
                          }}
                        >1</button>
                      );
                      if (start > 1) pages.push(<span key="start-ellipsis" style={{ padding: "0 4px" }}>...</span>);
                    }

                    for (let i = start; i <= end; i++) {
                      pages.push(
                        <button key={i} onClick={() => setCurrentPage(i)}
                          style={{
                            width: "32px", height: "32px",
                            border: currentPage === i ? "2px solid #128c7e" : "1px solid #d9d9d9",
                            borderRadius: "4px",
                            backgroundColor: currentPage === i ? "#128c7e" : "white",
                            color: currentPage === i ? "white" : "#2E3353",
                            cursor: "pointer",
                            fontWeight: currentPage === i ? "700" : "400",
                            fontFamily: "SpaceGrotesk-Medium, sans-serif", fontSize: "13px",
                          }}
                        >{i + 1}</button>
                      );
                    }

                    if (end < totalPages - 1) {
                      if (end < totalPages - 2) pages.push(<span key="end-ellipsis" style={{ padding: "0 4px" }}>...</span>);
                      pages.push(
                        <button key={totalPages - 1} onClick={() => setCurrentPage(totalPages - 1)}
                          style={{
                            width: "32px", height: "32px",
                            border: "1px solid #d9d9d9", borderRadius: "4px",
                            backgroundColor: "white", cursor: "pointer",
                            color: "#2E3353",
                            fontFamily: "SpaceGrotesk-Medium, sans-serif", fontSize: "13px",
                          }}
                        >{totalPages}</button>
                      );
                    }
                    return pages;
                  })()}
                  <button
                    onClick={() => setCurrentPage((p) => Math.min(totalPages - 1, p + 1))}
                    disabled={currentPage >= totalPages - 1}
                    style={{
                      width: "32px", height: "32px",
                      border: "1px solid #d9d9d9", borderRadius: "4px",
                      backgroundColor: "white", cursor: currentPage >= totalPages - 1 ? "not-allowed" : "pointer",
                      color: currentPage >= totalPages - 1 ? "#bbb" : "#2E3353",
                      fontFamily: "SpaceGrotesk-Medium, sans-serif", fontSize: "13px",
                    }}
                  >
                    ›
                  </button>
                  <button
                    onClick={() => setCurrentPage(totalPages - 1)}
                    disabled={currentPage >= totalPages - 1}
                    style={{
                      width: "32px", height: "32px",
                      border: "1px solid #d9d9d9", borderRadius: "4px",
                      backgroundColor: "white", cursor: currentPage >= totalPages - 1 ? "not-allowed" : "pointer",
                      color: currentPage >= totalPages - 1 ? "#bbb" : "#2E3353",
                      fontFamily: "SpaceGrotesk-Medium, sans-serif", fontSize: "13px",
                    }}
                  >
                    »
                  </button>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  <span style={{ color: "#757575", fontSize: "12px" }}>
                    {tags.length} etiqueta{tags.length !== 1 ? "s" : ""} en total
                  </span>
                  <span style={{ color: "#d9d9d9" }}>|</span>
                  <span style={{ fontSize: "12px" }}>Ir a página:</span>
                  <input
                    type="number"
                    min="1"
                    max={totalPages}
                    value={goToPageInput}
                    onChange={(e) => setGoToPageInput(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        const page = parseInt(goToPageInput, 10);
                        if (page >= 1 && page <= totalPages) {
                          setCurrentPage(page - 1);
                          setGoToPageInput("");
                        }
                      }
                    }}
                    placeholder={`1-${totalPages}`}
                    style={{
                      width: "60px", height: "28px",
                      border: "1px solid #d9d9d9", borderRadius: "4px",
                      textAlign: "center",
                      fontFamily: "SpaceGrotesk-Medium, sans-serif", fontSize: "12px",
                      outline: "none",
                    }}
                  />
                </div>
              </div>
            )}
          </TableContent>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              padding: "8px 0",
            }}
          >
            <Button
              designV4
              onClick={handleActionButton}
              disabled={!isChecked?.some((x) => x === true)}
              style={{ opacity: !isChecked?.some((x) => x === true) ? 0.4 : 1 }}
            >
              {isLoading ? (
                <LoaderComponent width="22" height="22" />
              ) : (
                !isFromContacts ? "Continuar" : "Aplicar"
              )}
            </Button>
          </div>
        </BroadcastAppCard>
      </SelectTagWidgetContainer>
      {isLimitWarningOpen && (
        <div
          style={{
            position: "fixed",
            top: "0",
            left: "0",
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0,0,0,0.5)",
          }}
        >
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              backgroundColor: "white",
              padding: "70px",
              borderRadius: "10px",
              width: "600px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexWrap: "wrap",
            }}
          >
            <p
              style={{
                textAlign: "center",
                width: "100%",
                fontFamily: "SpaceGrotesk-Medium",
                fontStyle: "normal",
                fontWeight: "500",
                fontSize: "28px",
                color: "#2E3353",
              }}
            >
              Has sobrepasado el límite de envío diario de mensajes.
            </p>
            <p
              style={{
                textAlign: "center",
                width: "100%",
                fontFamily: "SpaceGrotesk-Medium",
                fontStyle: "normal",
                fontWeight: "500",
                fontSize: "28px",
                color: "#2E3353",
                marginBottom: "30px",
              }}
            >
              Los mensajes restantes se enviarán en los días siguientes.
            </p>
            <Button
              designV4
              onClick={handleModalActionButton}
              style={{
                width: "100%",
              }}
            >
              Entendido
            </Button>
            <button
              onClick={handleModalCancelButton}
              style={{
                width: "100%",
                marginTop: "20px",
                backgroundColor: "transparent",
                border: "none",
                outline: "none",
                cursor: "pointer",
                fontFamily: "SpaceGrotesk-Medium",
                fontStyle: "normal",
                fontWeight: "500",
                fontSize: "18px",
                color: "#2E3353",
              }}
            >
              Regresar
            </button>
          </div>
        </div>
      )}
      {isConjunctionSelectOpen && (
        <TransparentBackground>
          <ConjunctionContainer>
            <ConjunctionTitle>
              Seleccionaste más de una etiqueta,
            </ConjunctionTitle>
            <ConjunctionGreenTitle>
              ¿Cómo te gustaría que sean contactados?
            </ConjunctionGreenTitle>
            <ConjunctionOptions>
              <ConjunctionOption
                onClick={() => selectConjunctionType("intersection")}
              >
                <ConjunctionImg src={intersectionImg} alt="Intersección" />
                <p>
                  Enviar a los contactos que tienen todas las etiquetas
                  seleccionadas al mismo tiempo.
                </p>
                <input
                  type="checkbox"
                  value={conjunctionType === "intersection"}
                  checked={conjunctionType === "intersection"}
                  style={{ marginTop: "10px" }}
                />
              </ConjunctionOption>
              <ConjunctionOption
                onClick={() => selectConjunctionType("difference")}
              >
                <ConjunctionImg src={differenceImg} alt="Diferencia" />
                <p>
                  Enviar a los contactos que tienen al menos una etiqueta, pero
                  no todas al mismo tiempo.
                </p>
                <input
                  type="checkbox"
                  value={conjunctionType === "difference"}
                  checked={conjunctionType === "difference"}
                  style={{ marginTop: "10px" }}
                />
              </ConjunctionOption>
              <ConjunctionOption onClick={() => selectConjunctionType("union")}>
                <ConjunctionImg src={unionImg} alt="Unión" />
                <p>
                  Enviar a todos los contactos que contengan las etiquetas
                  elegidas.
                </p>
                <input
                  type="checkbox"
                  value={conjunctionType === "union"}
                  checked={conjunctionType === "union"}
                  style={{ marginTop: "10px" }}
                />
              </ConjunctionOption>
            </ConjunctionOptions>
            <ConjunctionButtonContainer>
             <ConjunctionButton onClick={closeConjunctionSelect}>
                Regresar
              </ConjunctionButton>
              <ConjunctionButton onClick={closeConjunctionSelect}>
                Guardar
              </ConjunctionButton>
            </ConjunctionButtonContainer>
          </ConjunctionContainer>
        </TransparentBackground>
      )}
    </>
  );
};

export default BroadcastSelectTagView;
